import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { retainActions } from "../../../../../../_actions";
import moment from "moment";
import { CampaignAttributionMetricsBuilder } from "../objects/CampaignAttributionMetricsBuilder";

export default function ({ startDate, endDate, organizationId, campaignId }) {
  const dispatch = useDispatch();

  useEffect(() => {
    const payload = {
      startDate: moment(startDate).startOf("day").toISOString(),
      endDate: moment(endDate).startOf("day").toISOString(),
      organizationId,
      campaignId,
    };
    dispatch(retainActions.getCampaignAttributionMetrics(payload));
  }, [startDate, endDate, organizationId, campaignId]);

  const retainMetrics = useSelector((state) => state.retain);
  const loading = retainMetrics.loadingAttributionMetrics;
  const attributionMetrics = retainMetrics.attributionMetrics;
  const builder = new CampaignAttributionMetricsBuilder();

  if (!loading) {
    builder.setOrderedWithin5DaysRatio(
      _.get(attributionMetrics, "orderedWithin5DaysRatio")
    );
    builder.setOrderedRecommendedCategoryRatio(
      _.get(attributionMetrics, "orderedRecommendedCategoryRatio")
    );
    builder.setLastTouchRatio(_.get(attributionMetrics, "lastTouchRatio"));
    builder.setUsedExactDiscountCodeRatio(
      _.get(attributionMetrics, "usedExactDiscountCodeRatio")
    );
    builder.setUsesAnyDiscountCodeRatio(
      _.get(attributionMetrics, "usesAnyDiscountCodeRatio")
    );
    builder.setOrderedRecommendedProductRatio(
      _.get(attributionMetrics, "orderedRecommendedProductRatio")
    );
  }

  const data = builder.metrics || {};
  return { loading, data };
}
